import { GlobalStylesPlk } from '@rbilabs/components-library';
import { DefaultTheme, GlobalStyleComponent } from 'styled-components';

export const BrandGlobalStyles: GlobalStyleComponent<{}, DefaultTheme> = GlobalStylesPlk;
